import axios from '@/libs/api.request'

export const getPermissionList = (params) => {
  return axios.request({
    method: 'get',
    params,
    url: '/permission'
  })
}

export const addPermission = (data) => {
  return axios.request({
    method: 'post',
    data,
    url: '/permission'
  })
}

export const editPermission = (data) => {
  return axios.request({
    method: 'put',
    data,
    url: '/permission'
  })
}

export const delPermission = (id) => {
  return axios.request({
    method: 'delete',
    url: '/permission/' + id
  })
}

export const getPermissionInfo = (id) => {
  return axios.request({
    method: 'get',
    url: '/permission/' + id
  })
}
